export interface CareerRole {
  title: string
  mandate: string
}

export const careerTrack: CareerRole[] = [
  {
    title: 'Chief Executive Officer / Managing Director',
    mandate:
      'Spearheaded organization-wide repositioning, driving global market entry and profitability.',
  },
  {
    title: 'Chief Financial Officer / VP of Strategy',
    mandate:
      'Structured capital raises, oversaw audit functions, and streamlined financial reporting systems.',
  },
  {
    title: 'Senior Board Advisory Roles',
    mandate:
      'Guided executive leadership teams on corporate restructuring, market expansion, and compliance strategy.',
  },
]

export const boardAppointments: string[] = [
  'Non-Executive Director',
  'Audit Committee Chair',
  'Strategy & Governance Member',
]

export const academicCredentials: string[] = [
  'Master of Business Administration (MBA)',
  'Advanced Corporate Governance Certifications',
]

export const civicEngagement: string[] = [
  'Leadership roles across non-profit foundations',
  'Industry advisory councils',
  'Community initiatives',
]
